
export const WarningSVG = ({ width = 24, height = 24, fill = 'orange', styles }) => {
    return (
        <svg style={{ ...styles, width, height, fill, verticalAlign: "middle" }} viewBox="0 0 24 24">
            <path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" />
        </svg>
    );
};